<template>
  <div>
    <div class="about-container">
      <ul class="head">
        <li v-for="(item, index) in curTabs" :key="index"
          :class="cur === index ? 'on' : ''"
          @click="changeCur(index)">{{item.text}}</li>
      </ul>
      <!-- 品牌介绍 -->
      <div v-if="cur === 0" class="about1">
        <div style="overflow: hidden">
          <div class="about1Left">
            <span class="wow fadeInUp" style="visibility: visible; animation-name: fadeInUp;">
              <h3>
                WELCOME TO LINK FUTURE COMMUNITY.
                <br>
                TO PROVIDE YOU, THE DREAM PURSUERS, A SWEET HOME.
                <br>
                HOME IS WHERE THE DREAM IS.
              </h3>
              <h2>以品质之居  致敬城市梦想家</h2>
              <ul>
                <li v-for="(item, index) in about1Left" :key="index">
                  <div class="ico"><img :src="item.url" alt=""></div>
                  <h6>{{item.h6}}</h6>
                  <h4>{{item.h4}}</h4>
                </li>
              </ul>
            </span>
          </div>
          <div class="about1Right">
            <span class="wow fadeInUp" style="visibility: visible; animation-name: fadeInUp;">
              <h1><img  class="trans-img" src="@/assets/img/logo.jpg" alt=""></h1>
              <div class="jj">
                <!-- <p>“LINK新界”是派米雷集团旗下租赁住房品牌。</p> -->
                <p>派米雷·LINK新界</p> 
                <p>集投资开发、运营服务，线上“租房平台”和线下“租赁社区”于一体的租赁住房综合服务商。</p>
                <p>以“创享新生活”为愿景，“工作+生活“为理念，打造“绿色、开放、共享、智慧”的未来社区。</p>
                <p>给追梦的你一个温馨的家——梦在哪 家就在哪!</p>
              </div>
            </span>
          </div>
        </div>
        <div class="bannerVideo">
          <img  class="trans-img" src="@/assets/img/about1.jpg" alt="">
          <div class="mb"></div>
        </div>
        <div class="content1">
          <div class="content1_box">
            <div class="pic wow fadeInRight" style="visibility: visible; animation-name: fadeInRight;">
               <img  class="trans-img" src="@/assets/img/about2.jpg" alt="">
            </div>
            <div class="text wow fadeInLeft" style="visibility: visible; animation-name: fadeInLeft;">
              <h2 class="textColor">>  >  </h2>
              <h3>悦见幸福  拥揽品质生活</h3>
              <div class="jj">
                <p>“智慧”社区，以科技赋能美好生活 “绿色”社区，打造宜人宜居家园。</p>
                <p>“共享”社区，展望新型邻里场景 “开放”社区，开启生活“N”种可能。</p>
                <p>人与“家”的微妙关系，背后是无数种生活环境和方式的抉择。LINK新界未来社区已为您搭建好安居之所，只等您的入住，开启无忧生活！</p>
              </div>
            </div>
          </div>
        </div>
        <div class="content2">
          <div class="left">
             <img  class="trans-img" src="@/assets/img/about3.jpg" alt="">
          </div>
          <div class="right">
            <div class="text wow fadeInUp" style="visibility: visible; animation-name: fadeInUp;">
              <p>向往着在他乡闯出一番天地的年轻人拥有巨大的工作压力，面对着居高不下的房价、相对闭塞的社交圈，但即使有种种困扰，大城市的机遇和眼界、公平的发展空间、丰富精彩的夜生活依然让大家留在这里。</p>
              <p>“梦想的旅途，我背井离乡，肩上扛的行囊，装着对未来的梦想，我忍着泪望向夕阳，梦在前方，那是我最后的期望……”这首歌唱出了多少奋斗在他乡的青年居无定所的漂泊感，也唱出了那份拥有一个家的渴望。</p>
              <!-- <p>&nbsp;</p> -->
              <p>LINK新界，不愿您继续漂泊。LINK新界，给您一个温馨的家。</p>
              <p>LINK新界着眼于每个细节，注重高品质租赁住宅产品体验，优化空间布局，放大年轻生活圈，“主题公园”、“社交共享空间”让生活舒适有趣。</p>
              <!-- <p>&nbsp;</p> -->
              <p>我们希望，每一个为梦想而奔波的人都能找到舒心的住处，在拼搏的道路上始终有一个避风港，有后路，才能更好地前进。</p>
              <p>LINK新界未来社区，给追梦的你一个温馨的家。</p>
              <p>梦在哪 家就在哪！</p>
            </div>
          </div>
        </div>
      </div>
      <!-- 新闻动态 -->
      <div v-if="cur === 1" class="about2 news">
        <!-- 新闻列表页 -->
        <div v-if="page == 1">
          <div class="news_container">
            <ul>
              <li @click="goDetail(item, index)" v-for="(item, index) in timeLine" :key="index" class="wow fadeInUp" style="visibility: visible; animation-name: fadeInUp;">
                <a>
                  <div class="time">
                    {{substr(item.release_time_text, 5, 10)}} <span>{{substr(item.release_time_text, 0, 4)}}</span>
                  </div>
                  <div class="text">
                    <div class="pic">
                      <img  class="trans-img" :src="item.image" alt="">
                    </div>
                    <div class="title elli">{{item.title}}</div>
                    <!-- <div class="jj" v-html="item.content"></div> -->
                  </div>
                </a>
              </li>
            </ul>
          </div>
          <div class="pager">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              v-model:current-page="currentPage"
              :page-size="limit"
              @current-change="handleCurrentChange"
            ></el-pagination>
          </div>
        </div>
        <!-- 显示详情 -->
        <div v-if="page == 2">
          <news-detail :id="detailID" @back="page = 1"></news-detail>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import newsDetail from 'views/about/mobileNewsDetail.vue'
import { getListByTypeId } from '../../api/api.js'
import { ElMessage } from 'element-plus'
import { baseURL } from '../../utils/const.js'

export default {
  name: 'About',
  components: { newsDetail },
  data () {
    return {
      baseURL,
      detailID: '',
      cur: 0,
      curTabs: [{ text: '品牌介绍' }, { text: '新闻动态' }],
      total: 20,
      page: 1,
      currentPage: 1,
      limit: 8,
      about1Left: [
        { url: require('@/assets/img/icon/ruzhu-09.png'), h6: 'LINK FUTURE COMMUNITY OF SIJING ', h4: ' LINK新界（泗泾）' },
        { url: require('@/assets/img/icon/ruzhu-10.png'), h6: 'LINK FUTURE COMMUNITY OF LEDU', h4: ' LINK新界（乐都）' },
        { url: require('@/assets/img/icon/ruzhu-11.png'), h6: 'LINK FUTURE COMMUNITY OF CHEDUN', h4: ' LINK新界（车墩）' },
        { url: require('@/assets/img/icon/ruzhu-12.png'), h6: 'COMING SOON', h4: '持续探索...' }
      ],
      timeLine: []
    }
  },
  mounted () {
    new this.$wow.WOW().init()
  },
  methods: {
    handleCurrentChange (val) {
      this.currentPage = val
      this.newsList()
    },
    substr (str, start, end) {
      return str.substring(start, end)
    },
    changeCur (val) {
      this.cur = val
      if (val === 1) {
        this.newsList()
      }
    },
    async newsList () {
      const params = {
        page: this.currentPage,
        limit: this.limit,
        type_id: 1
      }
      try {
        const res = await getListByTypeId(params)
        this.total = res.data.total
        this.timeLine = res.data.data
      } catch (err) {
        ElMessage.error(err.message)
      }
    },
    goDetail (item, index) {
      if(item.open_type==2){
        window.open(item.uri)
        return
      }
      this.page = 2
      this.detailID = item.id
    }
  }
}
</script>

<style scoped lang="scss">
.about-container {
  padding: 50px 0 0 0;
  .head {
    background: #3b585b;
    color: #fff;
    padding: 15px 0 10px 0;
    text-align: center;
    margin-top: 0;
    margin-bottom: 0;
    li {
      display: inline-block;
      vertical-align: top;
      margin: 0 29px;
      cursor: pointer;
      font-size: 13px;
    }
    .on {
      color: #e5006e;
      border-bottom: 1px solid #e5006e;
    }
  }
  .about1 {
    overflow: hidden;
    .about1Left {
      width: 100%;
      float: left;
      height: 300px;
      display: table;
      background: #f4f1e7;
      color: #3b585b;
      span {
        display: block;
        padding: 20px;
      }
      h3 {
        font-size: 16px;
        line-height: 24px;
      }
      h2 {
        margin-top: 10px;
        font-size: 16px;
        line-height: 30px;
        letter-spacing: 1px;
      }
      ul {
        width: 100%;
        margin-top: 20px;
        padding-left: 0;
        overflow: hidden;
        li {
          width: 47%;
          text-align: center;
          float: left;
          margin-top: 25px;
          .ico {
            width: 100%;
            height: 50px;
            img {
              width: 50px;
              height: 50px;
            }
          }
          h6 {
            margin-top: 8px;
            line-height: 18px;
            font-size: 12px;
          }
          h4 {
            line-height: 20px;
            font-size: 13px;
          }
        }
      }
    }
    .about1Right {
      width: 100%;
      float: left;
      height: 300px;
      display: table;
      span {
        display: block;
        padding: 20px;
      }
      h1 {
        font-size: 24px;
        color: #3b585b;
        line-height: 24px;
        letter-spacing: 1px;
        img {
          width: 106px;
          height: 33px;
        }
      }
      .jj {
        margin-top: 20px;
        font-size: 14px;
        color: #3b585b;
        line-height: 24px;
        letter-spacing: 1px;
      }
    }
    .bannerVideo {
      width: 100%;
      height: 200px;
      position: relative;
      img {
        width: 100%;
        height: 100%;
      }
      .mb {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background: #000;
        z-index: 1;
        opacity: 0.3;
      }
    }
    .content1 {
      margin-top: 30px;
      padding: 0 10px;
      .content1_box {
        width: 100%;
        margin: 0 auto;
        color: #3b585b;
        overflow: hidden;
        .pic {
          width: 97%;
          float: left;
          position: relative;
          img {
            position: relative;
            width: 100%;
            z-index: 2;
          }
        }
        .pic:before {
          content: '';
          width: 100%;
          height: 100%;
          background: #efd3bb;
          position: absolute;
          right: -10px;
          bottom: -10px;
          z-index: 1;
        }
        .text {
          float: left;
          margin-top: 20px;
          width: 100%;
          h2 {
            font-size: 32px;
            line-height: 1;
            letter-spacing: 1px;
          }
          h3 {
            margin-top: 10px;
            font-size: 20px;
            line-height: 30px;
            letter-spacing: 1px;
          }
          .jj {
            margin-top: 10px;
            font-size: 13px;
            line-height: 20px;
            letter-spacing: 1px;
          }
        }
      }
    }
    .content2 {
      margin-top: 40px;
      overflow: hidden;
      .left {
        width: 100%;
        float: left;
        height: 300px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .right {
        width: 100%;
        float: right;
        height: 300px;
        display: table;
        background: #f4f1e7;
        .text {
          display: table-cell;
          vertical-align: middle;
          padding: 20px 5%;
          font-size: 13px;
          color: #3b585b;
          line-height: 22px;
          letter-spacing: 0.5px;
        }
      }
    }
  }
  .news {
    .news_container {
      width: 100%;
      margin: auto;
      overflow: hidden;
      ul {
        width: 100%;
        float: left;
        position: relative;
        padding-left: 0;
        li {
          width: 100%;
          float: left;
          padding: 0 0 0 78px;
          position: relative;
          z-index: 2;
          a:hover {
            .text {
              .title {
                border-bottom: 2px solid #3b585b;
                background: #f4f1e7;
              }
            }
          }
          .time {
            position: absolute;
            top: 53px;
            left: -40px;
            width: 150px;
            text-align: center;
            font-size: 20px;
            color: #3b585b;
            line-height: 27px;
            span {
              display: block;
              font-size: 16px;
              
              line-height: 22px;
              letter-spacing: 1px;
            }
          }
          .text {
            width: 100%;
            position: relative;
            top: 38px;
            height: 359px;
            border-bottom: dashed 1px #ccc;
            display: flex;
            flex-direction: column;
            align-items: center;
            .pic {
              width: 275px;
              height: 183px;
              margin-top: 10px;
              margin-bottom: 10px;
              img {
                width: 100%;
                height: 100%;
                position: relative;
                z-index: 2;
              }
            }
            .title {
              float: left;
              max-width: 100%;
              margin-left: -12px;
              font-size: 18px;
              color: #3b585b;
              line-height: 26px;
              letter-spacing: 1px;
            }
            .elli {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .jj {
              width: 100%;
              float: left;
              margin-top: 11px;
              font-size: 14px;
              color: #3b585b;
              line-height: 22px;
              letter-spacing: 1px;
              height: 140px;
              overflow: hidden;
              display: -webkit-box;
              text-overflow: ellipsis;
              -webkit-line-clamp: 5;
              -webkit-box-orient: vertical;
              word-break: break-all;
              p {
                margin: 0;
                padding: 0;
              }
            }
          }
          // .text:before {
          //   content: '';
          //   width: 5px;
          //   height: 26px;
          //   position: absolute;
          //   left: -3px;
          //   top: 60px;
          //   background: #f9c728;
          // }
        }
      }
      ul:before {
        content: '';
        width: 1px;
        height: 98%;
        position: absolute;
        bottom: 0;
        left: 72px;
        background: #d9d9d9;
        z-index: 1;
      }
    }
    .pager {
      margin: 40px auto;
      text-align: center;
    }
  }
  
}

</style>
